export const enum UserKeyPackageType {
  SINGLE = 'single',
  GROUP = 'group',
}

export const enum UploadFileCategory {
  AVATAR = 'avatar',
}
export interface uploadFileParams {
  type?: string;
  name?: string;
  category?: UploadFileCategory;
  date_part?: number;
}

export interface uploadFileResponse {
  url: string;
  name: string;
  public_host: string;
  access_url: string;
}
